import { render } from "./main.vue?vue&type=template&id=40ccf517&ts=true"
import script from "./main.vue?vue&type=script&lang=ts&config=true"
export * from "./main.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__